import Vue from "vue";
import Router from "vue-router";

const getUserSession = () => localStorage.getItem("ustk");

const getUserData = () => localStorage.getItem("udt");

Vue.use(Router);

const AUTH = "AUTHORIZE", ANON = "ANONYMOUS", ROOT = "ROOT";

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      meta: ANON, //ROOT
      component: () => import("./views/Landing/Landing.vue")
    },
    {
      path: "/landing",
      name: "landing",
      meta: ANON,
      component: () => import("./views/Landing/Landing.vue")
    },
    {
      path: "/pricing",
      name: "pricing",
      meta: ANON,
      component: () => import("./views/Landing/Pricing.vue")
    },
    {
      path: "/about",
      name: "about",
      meta: ANON,
      component: () => import("./views/Landing/About.vue")
    },
    {
      path: "/callback",
      name: "callback",
      meta: ANON,
      component: () => import("./views/Callback/Callback.vue")
    },
    {
      path: "/feed",
      name: "feed",
      meta: AUTH,
      component: () => import("./views/Feed/Feed.vue")
    },
    {
      path: "/404",
      name: "404",
      meta: ANON,
      component: () => import("./views/404/404.vue")
    },
    {
      path: "/circle/:id",
      name: "circle",
      meta: AUTH,
      component: () => import("./views/Circle/Circle.vue")
    },
    {
      path: "/circle/:parent_id/child/:id",
      name: "child_circle",
      meta: AUTH,
      component: () => import("./views/Circle/Circle.vue")
    },
    {
      path: "/profile/:id",
      name: "profile",
      meta: AUTH,
      component: () => import("./views/Profile/Profile.vue")
    },
    {
      path: "/redirect/circle/:parent_id/:id",
      name: "redirect_child_circle",
      meta: AUTH,
      component: () => import("./views/Redirect/Redirect.vue")
    },
    {
      path: "/setup",
      name: "setup",
      meta: AUTH,
      component: () => import("./views/FirstLogin/FirstLogin.vue")
    },
    {
      path: "/apps",
      name: "apps",
      meta: ANON,
      component: () => import("./views/Landing/Apps.vue")
    },
    {
      //this needs to be reordered to work with /v/blog
      // done
      path: "/blog",
      name: "blog",
      meta: ANON,
      component: () => import("./views/Blog/Blog.vue")
    },
    {
      //this needs to be reordered to work with /v/blog/something
      // done
      path: "/blog/post/:id",
      name: "blogpost",
      meta: ANON,
      component: () => import("./views/BlogPost/BlogPost.vue")
    },
    {
      //this will have to be reordered to work with /v/covid19tracker
      // done
      path: "/covid19tracker",
      name: "covid19tracker",
      meta: ANON,
      component: () => import("./views/Covid19Tracker/Covid19Tracker.vue")
    },
    {
      //this will now be /status and should have routes able to redirect to a circle and topic
      path: "/howfar",
      name: "howfar",
      meta: ANON,
      component: () => import("./views/HowFar/HowFar.vue")
    },
    {
      path: "/status",
      name: "status",
      meta: ANON,
      component: () => import("./views/Status/Status.vue")
    },
    {
      path: "/status/:circle_id",
      name: "statuscircle",
      meta: ANON,
      component: () => import("./views/Status/Status.vue")
    },
    {
      path: "/status/:circle_id/:topic_id",
      name: "statuscircletopic",
      meta: ANON,
      component: () => import("./views/Status/Status.vue")
    },
    {
      path: "/v/:vanity_url",
      name: "vanity",
      meta: ANON,
      component: () => import("./views/Vanity/Vanity.vue")
    },
    {
      path: "/v/:vanity_url/:id",
      name: "vanitypost",
      meta: ANON,
      component: () => import("./views/PollyPost/PollyPost.vue")
    },
    {
      //this will have to be reordered to work with /v/volunteer
      // done
      path: "/call",
      name: "call",
      meta: ANON,
      component: () => import("./views/Call/Call.vue")
    },
    {
      path: "*",
      redirect: "/404"
    }
  ]
});

router.beforeEach((to, from, next) => {
  const ALLOW_ROUTE_AUTH = (getUserSession() && getUserData());

  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start();
  }

  switch (to.name) {
    case 'covid19tracker':
      next({ path: '/v/covid19tracker' })
      break;

    case 'howfar':
      next({ path: '/status' })
      break;

    case 'blog':
      next({ path: '/v/blog' })
      break;

    case 'blogpost':
      next({ path: `/v/blog/${to.params.id}` })
      break;

    case 'call':
      next({ path: `/v/volunteer` })
      break;

    default:
      break;
  }

  if (to.meta === AUTH) {
    if (!ALLOW_ROUTE_AUTH) {
      next({
        path: "/landing"
      });
    } else {
      next();
    }
  }

  if (to.meta === ROOT) {
    if (ALLOW_ROUTE_AUTH) {
      next({
        path: "/feed"
      });
    } else {
      next({
        path: "/"
      });
    }
  }

  if (to.meta === ANON) {
    next();
  }
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
